var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#212d34;}.c{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3dadf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.762,
    y1: 0.89,
    x2: 0.173,
    y2: 0.189,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e75a10"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 21,
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 9.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.047,3.7H0V0H1.052A1.832,1.832,0,0,1,3.025,1.851a1.868,1.868,0,0,1-.667,1.419A1.907,1.907,0,0,1,1.047,3.7ZM.716.626V3.072H.909a1.349,1.349,0,0,0,.98-.294,1.275,1.275,0,0,0,.4-.932,1.248,1.248,0,0,0-.4-.921,1.329,1.329,0,0,0-.98-.3Z",
    transform: "translate(0 0.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,3.7H.717V0H0Z",
    transform: "translate(3.355 0.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.483,1.48c-.43-.16-.556-.266-.556-.466,0-.233.225-.41.534-.41a.74.74,0,0,1,.578.3L2.413.41A1.6,1.6,0,0,0,1.334,0,1.082,1.082,0,0,0,.187,1.059c0,.509.231.77.9,1.014a2.859,2.859,0,0,1,.5.211.444.444,0,0,1,.215.383.525.525,0,0,1-.557.522.847.847,0,0,1-.782-.493L0,3.144a1.426,1.426,0,0,0,1.272.7A1.188,1.188,0,0,0,2.54,2.634c0-.588-.242-.853-1.057-1.154",
    transform: "translate(4.342 0.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,1.935a1.909,1.909,0,0,0,1.94,1.93,1.972,1.972,0,0,0,.9-.215V2.8a1.143,1.143,0,0,1-.865.405A1.205,1.205,0,0,1,.739,1.93,1.226,1.226,0,0,1,1.94.66a1.2,1.2,0,0,1,.9.416V.227A1.821,1.821,0,0,0,1.957,0,1.938,1.938,0,0,0,0,1.935",
    transform: "translate(7.107 0.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.763,2.484.783,0H0L1.559,3.793h.386L3.533,0H2.756Z",
    transform: "translate(13.866 0.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,3.7H2.033V3.072H.716v-1H1.984V1.447H.716V.627H2.033V0H0Z",
    transform: "translate(17.723 0.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.716,3.7H0V0H1.063c.826,0,1.3.4,1.3,1.092A.983.983,0,0,1,1.526,2.14L2.682,3.7l-.88,0L.809,2.212H.716V3.7Zm0-3.117V1.7H.925c.459,0,.7-.2.7-.572,0-.359-.238-.548-.689-.548Z",
    transform: "translate(20.231 0.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.91,1.967A1.955,1.955,0,1,1,1.955,0,1.961,1.961,0,0,1,3.91,1.967",
    transform: "translate(10.18)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDiscover);
export default __webpack_public_path__ + "static/media/icn-discover.d645b7519bc0699feda1b464fccb1a95.svg";
export { ForwardRef as ReactComponent };